import { AuthState } from '@okta/okta-auth-js';

import { TransactionTypes } from '../../services/backend/TransactionTypes';
import { useBaseApiClient } from '../useBaseApiClient';

export const useTransactionTypes: () => TransactionTypes<AuthState> = () => {
  return useBaseApiClient(TransactionTypes);
};
